import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  debug: process.env.NODE_ENV === 'development',
  fallbackLng: 'sk',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    sk: {
      translation: {
        general: {
          header: 'SRDCE POD KONTROLOU',
          save: 'Uložiť',
          choose: 'Vyberte',
          level: 'stupeň',
          accept: 'Prijať',
          reject: 'Zamietnuť',
          startWriting: 'Začnite písať',
          addNote: 'Napíšte  poznámku',
        },
        addRecord: {
          addRecord: 'Pridať záznam',
          riskLevel: 'Stupeň rizika',
          programStep: 'Krok programu',
          fillAll: 'Prosím, vyplňte všetky polia',
          nextCheck: 'Najbližšia kontrola',
          plannedCheck: 'Naplánovaná kontrola',
        },
        feedStatus: {
          patientRequestedMembership: 'Pacient si požiadal o aktiváciu programu',
          patientActivated: 'Pacient si aktivoval program',
          patientAccepted: 'Pacient bol pridaný do programu',
          patientNotAccepted: 'Pacient nebol prijatý do programu',
          patientEVisitAssigned: 'Pacientovi bol pridelený e-termín',
          patientEVisitNotAssigned: 'Pacientovi sa nepodarilo priradiť e-termín',
          patientAssignedToRunningPeriod: 'Pacient bol pridaný do 14 dňovej running periódy',
          patientCompletedRunningPeriod: 'Pacient úspešne ukončil 14 dňovú running periódu',
        },
        feedAddEVisit: {
          title: 'Prosím pridelte pacientovi e-termín',
          confirmCheckboxLabel: 'Pacientovi bol pridelený e-termín',
        },
        addRunningCycleRecord: {
          checkboxes: {
            diabetes: 'Cukrovka',
            obesity: 'Nadváha',
            smoker: 'Fajčiar',
            info4: 'Info 4',
            info5: 'Info 5',
            info6: 'Info 6',
            info7: 'Info 7',
            info8: 'Info 8',
          },
          programType: {
            placeholder: 'Typ programu',
            '1': 'Running perióda',
            '2': '1',
            '3': '2',
            '4': '3',
            '5': 'Ukončiť program',
          },
          feed: {
            medicalRecord: 'Lekársky záznam',
            step: 'Krok programu',
            examination: 'Kontrola',
          },
        },
        newRequest: {
          patientRequest:
            'Pacient absolvoval prvý krok - diagnostiku. Žiada o prijatie do programu.',
          title: 'Pacient absolvoval prvý krok - diagnostiku. Žiada o prijatie do programu.',
          patientRejected: 'Prosím uveďte dôvod odmietnutia pacienta',
        },
        nextCheck: {
          in1Week: 'o 1 týždeň',
          in2Weeks: 'o 2 týždne',
          in1Month: 'o 1 mesiac',
          in2Months: 'o 2 mesiace',
          in3Months: 'o 3 mesiace',
          in6Months: 'o 6 mesiacov',
        },
      },
    },
    cs: {
      translation: {
        general: {
          header: 'SRDCE POD KONTROLOU',
          save: 'Uložit',
          choose: 'Vyberte',
          level: 'stupeň',
          accept: 'Přijmout',
          reject: 'Zamítnout',
          startWriting: 'Začněte psát',
          addNote: 'Vložte poznámku',
        },

        addRecord: {
          addRecord: 'Přidat záznam',
          riskLevel: 'Stupeň rizika',
          programStep: 'Krok programu',
          fillAll: 'Prosím, vyplňte všechny pole',
          nextCheck: 'Nejbližší kontrola',
          plannedCheck: 'Naplánovaná kontrola',
        },
        feedStatus: {
          patientRequestedMembership: 'Pacient vyžádal aktivaci programu',
          patientActivated: 'Pacient si aktivoval program',
          patientAccepted: 'Pacient byl přidán do programu',
          patientNotAccepted: 'Pacient nebyl přijatý do programu',
          patientEVisitAssigned: 'Pacientovi byl přiřazen e-termín',
          patientEVisitNotAssigned: 'Pacientovi sa nepodarilo přiřadit e-termín',
          patientAssignedToRunningPeriod: 'Pacientov byl přiřazen do 14 dnové running periody',
          patientCompletedRunningPeriod: 'Pacient úspěšně ukončil 14 denní running periodu',
        },
        feedAddEVisit: {
          title: 'Prosím přidělte pacientovi e-termín',
          confirmCheckboxLabel: 'Pacientovi byl přidělen e-termín',
        },
        addRunningCycleRecord: {
          checkboxes: {
            diabetes: 'Cukrovka',
            obesity: 'Nadváha',
            smoker: 'Kuřák',
            info4: 'Info 4',
            info5: 'Info 5',
            info6: 'Info 6',
            info7: 'Info 7',
            info8: 'Info 8',
          },
          programType: {
            placeholder: 'Typ programu',
            '1': 'Running perióda',
            '2': '1',
            '3': '2',
            '4': '3',
            '5': 'Ukončiť program',
          },
          feed: {
            medicalRecord: 'Lékařský záznam',
            step: 'Krok programu',
            examination: 'Kontrola',
          },
        },
        newRequest: {
          title: 'Pacient absolvoval první krok - diagnostiku. Žádá o přijetí do programu.',
          patientRejected: 'Prosím uveďte důvod odmítnutí pacienta',
        },
        nextCheck: {
          in1Week: 'za 1 týden',
          in2Weeks: 'za 2 týdny',
          in1Month: 'za 1 měsíc',
          in2Months: 'za 2 měsíce',
          in3Months: 'za 3 měsíce',
          in6Months: 'za 6 měsíců',
        },
      },
    },
    en: {
      translation: {
        general: {
          header: 'HEART UNDER CONTROL',
          save: 'Save',
          choose: 'Choose',
          level: 'degree',
          accept: 'Accept',
          reject: 'Reject',
          startWriting: 'Start writing',
          addNote: 'Add note',
        },
        addRecord: {
          addRecord: 'Add an entry',
          riskLevel: 'Degree of risk',
          programStep: 'Program step',
          fillAll: 'Please fill in all fields',
          nextCheck: 'Next check',
          plannedCheck: 'Scheduled checkup',
        },
        feedStatus: {
          patientRequestedMembership: 'Patient requested program membership',
          patientActivated: 'The patient has activated the program',
          patientAccepted: 'The patient has been admitted to the program',
          patientNotAccepted: 'The patient was not admitted to the program',
          patientEVisitAssigned: 'The patient was assigned e-visit',
          patientEVisitNotAssigned: 'The Patient could not be assigned an e-visit',
          patientAssignedToRunningPeriod: 'The patient was assigned to 14-day running period',
          patientCompletedRunningPeriod:
            'The patient successfully completed the 14-day running period',
        },
        feedAddEVisit: {
          title: 'Please assign the patient to an e-visit',
          confirmCheckboxLabel: 'The patient has been assigned e-visit',
        },
        addRunningCycleRecord: {
          checkboxes: {
            diabetes: 'Diabetes',
            obesity: 'Obesity',
            smoker: 'Smoker',
            info4: 'Info 4',
            info5: 'Info 5',
            info6: 'Info 6',
            info7: 'Info 7',
            info8: 'Info 8',
          },
          programType: {
            placeholder: 'Program type',
            '1': 'Running period',
            '2': '1',
            '3': '2',
            '4': '3',
            '5': 'Finish the program',
          },
          feed: {
            medicalRecord: 'Medical record',
            step: 'Step',
            examination: 'Examination',
          },
        },
        newRequest: {
          title:
            'The patient completed the first step - diagnosis. He is applying to be admitted to the program.',
          patientRejected: `Please write the reason for the patient's refusal`,
        },
        nextCheck: {
          in1Week: 'in 1 week',
          in2Weeks: 'in 2 weeks',
          in1Month: 'in 1 month',
          in2Months: 'in 2 months',
          in3Months: 'in 3 months',
          in6Months: 'in 6 months',
        },
      },
    },
  },
})

export default i18n
